/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConfigurationLocationKey, ConfigurationLocationState } from './configuration-location-reducer';

export const selectConfigurationLocationState =
  createFeatureSelector<ConfigurationLocationState>(ConfigurationLocationKey);

export const selectFolderPath = createSelector(selectConfigurationLocationState, (state) => ({
  folderPath: state.folderPath,
  statusCode: state.statusCode,
}));
